import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const SUPPORT_SCRIPT_ID = 'rex-support-embed';
const SUPPORT_POSITION_STYLE_ID = 'rex-support-position';
const SUPPORT_SCRIPT_SRC = 'https://rex-support-os.vercel.app//embed.js';
const NPS_SCRIPT_ID = 'rex-nps-embed';
const NPS_SCRIPT_SRC = 'https://rex-support-os.vercel.app/nps-embed.js';

export default function RexSupportWidget() {
  const { user, isAuthenticated } = useAuth0();

  useEffect(() => {
    if (!isAuthenticated || !user) return;

    window.RexSupport = {
      user: {
        email: user.email ?? '',
        name: user.name ?? '',
        id: user.sub ?? '',
      },
    };

    if (!document.getElementById(SUPPORT_POSITION_STYLE_ID)) {
      const style = document.createElement('style');
      style.id = SUPPORT_POSITION_STYLE_ID;
      // The embed pins itself to the bottom-right and covers the pager.
      // Dock the closed launcher in the left sidebar column instead.
      style.textContent = 'iframe[title="Support chat"] { right: auto !important; left: 0 !important; }';
      document.head.appendChild(style);
    }

    if (!document.getElementById(SUPPORT_SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = SUPPORT_SCRIPT_ID;
      script.src = SUPPORT_SCRIPT_SRC;
      script.defer = true;
      script.dataset.rexSupportProduct = 'tenantport';
      document.head.appendChild(script);
    }

    if (!document.getElementById(NPS_SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = NPS_SCRIPT_ID;
      script.src = NPS_SCRIPT_SRC;
      script.defer = true;
      script.dataset.rexNpsProduct = 'tenantport';
      document.head.appendChild(script);
    }

    return () => {
      document.getElementById(SUPPORT_SCRIPT_ID)?.remove();
      document.getElementById(NPS_SCRIPT_ID)?.remove();
      document.getElementById(SUPPORT_POSITION_STYLE_ID)?.remove();
      delete window.RexSupport;
    };
  }, [isAuthenticated, user?.sub]);

  return null;
}
